var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1806.47 309.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 419.3,
    y1: 13.23,
    x2: 646.83,
    y2: 240.77,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 310)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fca10a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 789.46,
    y1: 13.23,
    x2: 1017,
    y2: 240.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1159.62,
    y1: 13.23,
    x2: 1387.17,
    y2: 240.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 49.13,
    y1: 13.23,
    x2: 276.67,
    y2: 240.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1529.79,
    y1: 13.23,
    x2: 1757.34,
    y2: 240.78,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stars02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "533.07 0 583.41 102 695.97 118.36 614.52 197.75 633.75 309.86 533.07 256.93 432.39 309.86 451.62 197.75 370.16 118.36 482.73 102 533.07 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "903.23 0 953.57 102 1066.13 118.36 984.68 197.75 1003.91 309.86 903.23 256.93 802.55 309.86 821.78 197.75 740.33 118.36 852.89 102 903.23 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1273.39 0 1323.73 102 1436.3 118.36 1354.85 197.75 1374.07 309.86 1273.39 256.93 1172.71 309.86 1191.94 197.75 1110.49 118.36 1223.06 102 1273.39 0"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "162.9 0 213.24 102 325.81 118.36 244.35 197.75 263.58 309.86 162.9 256.93 62.22 309.86 81.45 197.75 0 118.36 112.56 102 162.9 0"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1643.56 0 1693.9 102 1806.47 118.36 1725.02 197.75 1744.24 309.86 1643.56 256.93 1542.88 309.86 1562.11 197.75 1480.66 118.36 1593.23 102 1643.56 0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars02);
export default __webpack_public_path__ + "static/media/stars02.35f75484501e7ee12339e3865c230a4f.svg";
export { ForwardRef as ReactComponent };